export const FETCHURI =
{
    PostExecuteRequest: '/WebApp/PostExecuteRequest',
    DeleteExecuteRequest:'/WebApp/DeleteExecuteRequestWithBody',
    PostExecuteFormRequest: '/WebApp/PostExecuteRequestForm',
    PostExecuteRequestFormShare: '/WebApp/PostExecuteRequestFormShare',
    PostExecuteRequestFormUpload: '/WebApp/PostExecuteRequestFormUpload',
    GetExecuteRequest: '/WebApp/GetExecuteRequest?endPoint=',
    GetRequestAsync: '/WebApp/GetExecuteRequest?endPoint=',
    GetLinkBlobFile: '/WebApp/GetBlobFile?uType={utype}&enumValue={isTranslate}',
    GetGoogleTimeZone: '/WebApp/GetGoogleMapTimeZone?',
    GetCustomerSupport: '/CustomerSupport/listingScreen',
    PutExecuteRequest: '/WebApp/PutExecuteRequest',
    GetExecuteRequestNoAuth: '/WebApp/GetExecuteRequestNoAuth?endPoint=',
    PostExecuteRequestNoAuth: '/WebApp/PostExecuteRequestNoAuth',
    GetBingMapUrlNoAuthInstance: '/WebApp/GetBingMapUrlNoAuthInstance?endPoint=',
}